var now = new Date();
var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

export function DATE_TO_STR(date) {
  `
  Date 객체를 YYYY-MM-DD 형태의 문자열로 변환하는 헬퍼 함수.
  `;
  date.setHours(9);
  return date.toISOString().split("T")[0];
}

export function GET_STATUS(start, end) {
  `
  시작일과 종료일을 입력받아 오늘 날짜를 기준으로 캠페인의 상태를 반환하는 헬퍼 함수.

  Args:
    start(String): YYYY-MM-DD (ex. 2018-12-25)
    end(String): YYYY-MM-DD (ex. 2018-12-31)

  Result:
    String: 오류 or 종료 or 진행중 or 예약
  `;
  let status = "";
  let startDateStr = start.split("-");
  let endDateStr = end.split("-");
  let startDate = new Date(
    startDateStr[0],
    startDateStr[1] - 1,
    startDateStr[2]
  );
  let endDate = new Date(endDateStr[0], endDateStr[1] - 1, endDateStr[2]);

  if (endDate < startDate || startDate < 0 || endDate < 0) {
    status = "오류";
  } else if (today > endDate && today > startDate) {
    status = "종료";
  } else if (today >= startDate && today <= endDate) {
    status = "진행중";
  } else {
    status = "예약";
  }

  return status;
}

export function numberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const format = (format = "yyyy-MM-DD", date = Date.now()) => {
  let tempD = date;
  const timezone = /\\Z$/.test(tempD);

  if (timezone) {
    tempD = date.substring(0, date.length - 1);
  }

  const _date = new Date(tempD);

  return format.replace(/(yyyy|mm|dd|MM|DD|H|h|loc|i|s|a)/g, (t) => {
    switch (t) {
      case "yyyy":
        return _date.getFullYear();
      case "mm":
        return _date.getMonth() + 1;
      case "dd":
        return _date.getDate();
      case "MM":
        return zero(_date.getMonth() + 1);
      case "DD":
        return zero(_date.getDate());
      case "H":
        return zero(_date.getHours());
      case "h":
        return minHour(_date.getHours());
      case "i":
        return zero(_date.getMinutes());
      case "s":
        return zero(_date.getSeconds());
      case "a":
        return krTime(_date.getHours()); // 오전 오후
      case "loc":
        return "T" + zero(_date.getHours()); // local : using for input type='datetime-local'
      default:
        return false;
    }
  });
};

// use for dateFormat
export const _now = () => Date.now();
export const pure = (value) => new Date(value);
export const krTime = (value) => (value >= 0 && 12 >= value ? "오전" : "오후");
export const zero = (value) =>
  value.toString().length === 1 ? `0${value}` : value;
export const minHour = (value) => (value > 12 ? zero(value - 12) : zero(value));
